
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"#0D69D5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_106_1698)"}},[_c('path',{attrs:{"d":"M13.353 15.813l-.152-.202c-.817-1.067-1.774-1.97-2.988-2.569-.8-.392-1.633-.642-2.537-.523-.735.098-1.3.452-1.568 1.182-.163.451-.136.92-.06 1.388.022.136.077.207.213.234.13.027.261.081.386.125 1.274.463 2.346 1.241 3.342 2.14 1.035.93 1.97 1.97 2.853 3.053.01.01.016.022.027.032.713.877 2.117.6 2.45-.479.076-.25.146-.479.206-.67.898-2.873 1.91-5.71 3.283-8.398a32.155 32.155 0 013.794-5.84c1.6-1.966 3.418-3.707 5.4-5.28-.006-.011 0 .005 0-.006-7.23 3.08-12.09 8.36-14.649 15.813z"}}),_c('path',{attrs:{"d":"M21.833 27.998H6.162A6.17 6.17 0 010 21.837V6.166A6.17 6.17 0 016.162.004h12.813a.772.772 0 110 1.546H6.162A4.62 4.62 0 001.54 6.166v15.676a4.622 4.622 0 004.616 4.616h15.677a4.622 4.622 0 004.616-4.616v-11.61a.772.772 0 111.546 0v11.61a6.17 6.17 0 01-6.162 6.162v-.006z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_106_1698"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h28v28H0z"}})])])])
          )
        }
      }
    